import { render, staticRenderFns } from "./AlternativeEans.vue?vue&type=template&id=8aa81474"
import script from "./AlternativeEans.vue?vue&type=script&lang=js"
export * from "./AlternativeEans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports